import React from "react";
import { connect } from "react-redux";
import AvatarPage from "../../../../avatar-page";
import { replaceParagraph } from "../../../../SlateEditor/constant/Helper";

const UserInput = (props) => {
   const { page, card } = props;
   const getTypeReply = () => {
      const { user_input } = card;
      switch (user_input.reply_type) {
         case 'phone':
            return '0987654321'
         case 'text':
            return 'Tin nhắn từ khách hàng'

      }
   }
   return (
      <React.Fragment>
         <div className="row-wrapper">
            <div className="">
               <AvatarPage />
            </div>
            <div className="row-wrapper__children">
               <div className="card-text">
                  <div className="card-text__content">
                     <span>
                        {replaceParagraph(card.title)}
                     </span>
                  </div>
               </div>
            </div>
         </div>
         <div className="row-wrapper__reply">
            <div><span>{getTypeReply()}</span></div>
         </div>
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   const { page } = state;
   return {
      page
   };
};

export default connect(mapStateToProps, {})(UserInput);